<template>
  <div>Loading... {{ time }}</div>
  <i class="fas fa-spinner fa-spin"></i>
</template>

<script src="./Loading.js"></script>
<style lang="scss" scoped src="./Loading.scss">
</style>